import Vue from "vue";
import VueRouter from "vue-router";
import Success from "../views/Facility/PaySuccess";
import SlotList from "../views/Facility/SlotList";
import Landing from "../views/Facility/Landing";
import TermsPage from "../views/Facility/TermsAndConditions";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Landing",
    component: Landing
  },
  {
    path: "/facility/slots",
    name: "SlotList",
    component: SlotList
  },
  {
    path: "/facility/slot/success/:id",
    name: "Success",
    component: Success
  },
  {
    path: "/booking/tAndC/:id",
    name: "TermsPage",
    component: TermsPage
  },
  {
    path: '/*',
    redirect: '/',
  },
];

const router = new VueRouter({
  routes
});

export default router;
